import { LanguageEnum } from '../LocalizedStrings';
import {
  AuthProtocolRefreshTokenResponse,
  FolioCommonEnumsDiscountEnum,
  FolioCommonEnumsFolioCountryCodeEnum,
  FolioCoreModelApStatusSectionDto,
  FolioCoreModelApTmReferenceDto,
} from '../swagger/data-contracts';

export type ILocalizedString = { [lang in LanguageEnum]: string };

export interface IFilenameUrl {
  filename: string;
  url: string;
}

export interface IRefFile extends IFilenameUrl {
  id?: number;
}

export enum TrademarkTypeEnum {
  Word = 'word',
  Logo = 'logo',
  Composite = 'composite',
}

export interface ITrademarkDto {
  imageName?: string;
  imageUrl?: string;
  stylized?: boolean;
  trademarkType: TrademarkTypeEnum;
  word: string;
}

export interface IClass {
  id: number;
  title: ILocalizedString;
  identifier: ILocalizedString;
  subClassList: ISubClass[];
}

export interface ISubClass extends Omit<IClass, 'identifier' | 'subClassList'> {
  isOthers: boolean;
  isGlobal: boolean;
  selectable: boolean;
}

export interface IPrice {
  addPrice: 0;
  firstPrice: 0;
}

export interface ICountryWithClass {
  countryCode: FolioCommonEnumsFolioCountryCodeEnum;
  price?: IPrice;
  subClassIdList: number[];
  otherNotesMap?: { [k: string]: string };
}

export interface IApplication {
  countryClassList: ICountryWithClass[];
  newCountries?: string;
  id?: number;
  reference: FolioCoreModelApTmReferenceDto;
  trademark: ITrademarkDto;
}

// move to component
export enum BusinessTypeEnum {
  Individual = 'individual',
  Business = 'corporate',
}

export interface IApplicant {
  businessType: BusinessTypeEnum;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string;
  email?: string;
  ownerFirstName?: string;
  ownerLastName?: string;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber: string;
  updateInfo?: boolean;
  referralCode?: string;
  isDocusignAgreement?: boolean;
}

export interface IDiscount {
  name: FolioCommonEnumsDiscountEnum;
  percent: number;
}

export interface ICard {
  brand?: string;
  lastFour?: string;
  paymentMethodId: string;
}

export interface IAddNewCard {
  cardHolder: string;
  cardNumber: string;
  expirationDate: string;
  cvvcvc: string;
}

export type IBillingDetail = Omit<IApplicant, 'updateInfo' | 'referralCode' | 'isDocusignAgreement'> & {
  address: IAddress;
};

export interface IAddress {
  streetAddress: string | null;
  city: string | null;
  zipcode: string | null;
  country: FolioCommonEnumsFolioCountryCodeEnum | null;
}

export interface IPayment {
  reqId: number;
  discounts: IDiscount[];
  payValidDate: string;
  cards: ICard[];
}

export interface ISignInUp {
  email: string;
  password: string;
  termsAgreement: boolean;
  token: string;
  haveAccount?: boolean;
}

export type IApplicationWithApplicant = IApplication &
  IApplicant &
  ISignInUp &
  IAddress &
  Partial<AuthProtocolRefreshTokenResponse>;

export interface ICountry {
  code: FolioCommonEnumsFolioCountryCodeEnum;
  name: ILocalizedString;
  group?: FolioCommonEnumsFolioCountryCodeEnum[];
  // EU 그룹은 phone code가 안정해져있음
  phone?: string;
}

export interface IApplicationStatus {
  id: number;
  submittedDate: string;
  updatedDate: string;
  newChat?: {
    countryList: FolioCommonEnumsFolioCountryCodeEnum[];
    from: string;
  };
  statusUpdated?: {
    countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  };
  summary: {
    classList: string[];
    countryList: FolioCommonEnumsFolioCountryCodeEnum[];
    imageUrl?: string;
    word?: string;
  };
  applicationStatus: FolioCoreModelApStatusSectionDto;
  applicationEdited: {
    showNoti: boolean;
    lastEditedDate: string | null;
  };
  hasPayReq: boolean;
  docQnaSubmit: {
    countryCode: FolioCommonEnumsFolioCountryCodeEnum;
    needed: boolean;
  };
  docReview: {
    countryCode: FolioCommonEnumsFolioCountryCodeEnum;
    needed: boolean;
  };

  expectedCompletionDate?: string | null;
  expired: boolean;
  hasAdditionalPayReq: boolean;
  additionalPayReqIdList?: number[] | null;
}
